View = require 'app/scripts/views/internal/view'

module.exports = class UploadingLinkView extends View
  viewTitleKey: 'sending links'
  render: ->
    @$el.html('<div class="spinner loading"></div>')
    @
